import { render, staticRenderFns } from "./InformationBox.vue?vue&type=template&id=3404af64&scoped=true&"
import script from "./InformationBox.vue?vue&type=script&lang=js&"
export * from "./InformationBox.vue?vue&type=script&lang=js&"
import style0 from "./InformationBox.vue?vue&type=style&index=0&id=3404af64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3404af64",
  null
  
)

export default component.exports